export default __webpack_public_path__ + "static/media/Moving.2fbab856.svg";